import { cx } from "@emotion/css";
import axios from "axios";
import $ from "jquery";
import keycode from "keycode";
import { useEffect, useRef } from "react";

// import { HandleLeadFormParameter } from "@/ExportedTypes/ExportedTypes";
import {
  canadaIsoCode,
  canadaUnitedStatesPhoneNumberRegularExpression,
  createCookie,
  dnbComLog,
  dnbGetCookie,
  getLocalizedMessage,
  getMarketoFormWrapper,
  getNonEmptyCookieValueOrUndefined,
  getParameterByName,
  getVisitorFrom,
  getWindowBizible,
  getWindowDigitalData,
  getWindowS,
  getWindowUnderscoreSatellite,
  hidCookieName,
  irelandIsoCode,
  isNotUndefined,
  isNotUndefinedOrNull,
  isUndefined,
  isUndefinedOrNull,
  isValidUnitedKingdomOrIrelandPostalCode,
  lazyLoadScriptMarketo,
  LogSeverity,
  trackGTMEvents,
  TrustArcGroupId,
  trustArcGroupIsActive,
  unitedStatesIsoCode,
  validateEmail,
  valToString,
  windowOnLoadOrImmediate,
} from "@/shared/FunctionCore";
import defaultHtml from "@/components/overlay/resources/DefaultLeadForm";
// import {
//   addToRenderableData,
//   RenderableData,
//   renderIdentifierGeneric,
// } from "@/RenderIdentifier";
import React from "react";
import { HandleLeadFormParameter } from "@/components/overlay/ContactData";
import { getDnbDirectUtilForEmail } from "@/services/businessDirectory";
const formErrorClassName = "form-error";
const formErrorMessageClassName = "form-error-message";

const removeDuplicateFormEntries = (
  array: JQuerySerializeArrayElement[],
  keys: string[]
): JQuerySerializeArrayElement[] => {
  const map: { [string: string]: JQuerySerializeArrayElement[] } = {};

  for (const currentValue of array) {
    const currentValueName = currentValue.name;

    const currentMapValue = map[currentValueName];

    let newMapValue: JQuerySerializeArrayElement[];

    if (isUndefined(currentMapValue)) {
      newMapValue = [];

      map[currentValueName] = newMapValue;
    } else {
      newMapValue = currentMapValue;
    }

    newMapValue.push(currentValue);
  }

  const returnValue: JQuerySerializeArrayElement[] = [];

  for (const property in map) {
    if (window.Object.prototype.hasOwnProperty.call(map, property)) {
      const mapValue = map[property]!;

      const numberOfValues = mapValue.length;

      if (keys.includes(property)) {
        const nonEmptyValues = mapValue.filter(
          (currentValue) =>
            typeof currentValue.value === "string" &&
            currentValue.value.length > 0
        );

        const numberOfNonEmptyValues = nonEmptyValues.length;

        if (numberOfNonEmptyValues === 0) {
          // All values are empty, use the first one
          returnValue.push(mapValue[0]!);
        } else {
          // Use the first non-empty value
          returnValue.push(nonEmptyValues[0]!);

          const numberOfEmptyValues = numberOfValues - numberOfNonEmptyValues;

          if (numberOfEmptyValues > 0) {
            dnbComLog(
              LogSeverity.ERROR,
              new Error(
                `Ignoring ${window.String(
                  numberOfEmptyValues
                )} empty values for key "${property}"`
              )
            );
          }

          if (numberOfNonEmptyValues !== 1) {
            dnbComLog(
              LogSeverity.ERROR,
              new Error(
                `Found ${window.String(
                  numberOfNonEmptyValues
                )} non-empty form values for key "${property}", only using the first one`
              )
            );
          }
        }
      } else {
        for (const currentValue of mapValue) {
          returnValue.push(currentValue);
        }

        if (numberOfValues > 1) {
          dnbComLog(
            LogSeverity.ERROR,
            new Error(
              `Found ${window.String(
                numberOfValues
              )} form values for key "${property}", only expecting one`
            )
          );
        }
      }
    }
  }

  return returnValue;
};

const ifFirstFieldExistsSetBothFields = (
  $firstField: JQuery,
  $secondField: JQuery,
  value: any
) => {
  if ($firstField.length > 0) {
    $firstField.val(value);
    $secondField.val(value);
  }
};

const setFieldValueIfExistsAndValueIsNotEmpty = (
  $field: JQuery,
  value: any
) => {
  if ($field.length > 0 && value.length > 0) {
    $field.val(value);
  }
};

const ifExistsSetValue = ($field: JQuery, valueProducer: () => any) => {
  if ($field.length > 0) {
    $field.val(valueProducer());
  }
};

const addError = ($field: JQuery, errorMessage: boolean | number | string) => {
  try {
    const fieldNameAttribute = $field.attr("name");

    const uniqueId = isNotUndefined(fieldNameAttribute)
      ? fieldNameAttribute
      : window.Math.floor(window.Math.random() * 900 + 100);

    const areaDescribeId = `form-${uniqueId}-error`;

    $field.attr("aria-describedby", areaDescribeId);

    const $formErrorMessage = $(`<span id=${areaDescribeId}></span>`)
      .addClass(formErrorMessageClassName)
      .text(errorMessage);

    $field.addClass(formErrorClassName).after($formErrorMessage);
  } catch (er) {
    dnbComLog(LogSeverity.ERROR, er);
  }
};

// const getDefaultLeadFormHtmlAssetInlineBaseSixtyFourDecoded = () => window.atob(defaultLeadFormHtmlAssetInline.slice("data:text/html;base64,".length));

const getLanguageToUse = (arrayOfLanguageStrings: string[]) => {
  const frRegularExpression = /fr/i;

  return arrayOfLanguageStrings.some(
    (st) => isNotUndefinedOrNull(st) && st.search(frRegularExpression) === 0
  )
    ? "fr"
    : "en";
};

interface LeadFormSettings {
  crmRequired: boolean;
  dialerEligiblePage1: string;
  eloquaCampaignId: string;
  enableSellTo: boolean;
  enableSubmitter: boolean;
  formId: string;
  formVid: string;
  formtype: string;
  instructions: string;
  leadPriority: string;
  leadSource: string;
  leadType: string;
  legalText: string;
  locale?: string;
  manualReviewFlag1: string;
  marketourl: string;
  munchkinId: string;
  partnerName1: string;
  preferredLanguage: string;
  productInterest: string;
  sFDCLastCampaignID: string;
  sFDCLastCampaignName: string;
  sfdccampaignid: string;
  siteOrigin: string;
  solutionInterest: string;
  submitButtonText: string;
  submitterRequired: boolean;
  submitterValue: string;
  tandc: string;
  termsconditions: string;
  thankyouMessage: string;
  thankyouPage: string;
  title: string;
  uNDUNSdToLDR1: string;
  visitorFrom1: string;
  warmTransferId: string;
}

// Z leadFormIsTwoStep: true if lead form is two step, false if lead form is one step
// Z leadFormIsCtaLeadForm: true if lead form is the global contact CTA lead form, false if lead form is a component lead form

const notEmptyString = (input: any) =>
  typeof input === "string" && input.length > 0;

/**
 * Show if true, hide if false
 *
 * @param $x - jQuery object to show or hide
 * @param show - if true, show, if false, hide
 */
const showIfTrueHideIfFalseWithSiblingsInLabel = (
  $x: JQuery,
  show: boolean
) => {
  const parentIsLabel = $x.parent().prop("tagName") === "LABEL";

  const $xOrXWithSiblings = parentIsLabel ? $x.add($x.siblings()) : $x;

  $xOrXWithSiblings.toggle(show);
};

type LeadFormSharedComponentProps = HandleLeadFormParameter & {
  fromFloatingContactOptions: boolean;
};

const removeError = ($field: JQuery) => {
  $field.removeAttr("aria-describedby");
  $field.removeClass(formErrorClassName);
};

const getFormSelectNameTitle = ($form: JQuery): JQuery =>
  $form.find('select[name="Title"]');

const getFormInputNameFirstName = ($form: JQuery): JQuery =>
  $form.find('input[name="FirstName"]');

const getFormInputNameLastName = ($form: JQuery): JQuery =>
  $form.find('input[name="LastName"]');

const getFormInputNameCountryC = ($form: JQuery): JQuery =>
  $form.find('input[name="Country"]');

const getFormInputNameAddress = ($form: JQuery): JQuery =>
  $form.find('input[name="Address"]');

const getFormInputNamePostalCode = ($form: JQuery): JQuery =>
  $form.find('input[name="PostalCode"]');

const getFormInputNameEmail = ($form: JQuery): JQuery =>
  $form.find('input[name="Email"]');

const getFormInputNamePhone = ($form: JQuery): JQuery =>
  $form.find('input[name="Phone"]');

const getCommentC = ($form: JQuery): JQuery =>
  $form.find('[name="comment__c"]');

const getEleadsProductInterestC = ($form: JQuery): JQuery =>
  $form.find('[name="eLeads_Product_Interest__c"]');

const getMktoFinTestimonialconsent = ($form: JQuery): JQuery =>
  $form.find('[name="mktoFINtestimonialconsent"]');

const getMktoPersonNotes = ($form: JQuery): JQuery =>
  $form.find('[name="MktoPersonNotes"]');

const hideFieldsForNetNewForm = ($form: JQuery) => {
  showIfTrueHideIfFalseWithSiblingsInLabel(
    getFormSelectNameTitle($form),
    false
  );
  showIfTrueHideIfFalseWithSiblingsInLabel(
    getFormInputNamePostalCode($form),
    false
  );
  showIfTrueHideIfFalseWithSiblingsInLabel(
    getFormInputNameAddress($form),
    false
  );
  showIfTrueHideIfFalseWithSiblingsInLabel(
    getFormInputNameCountryC($form),
    false
  );
};

const containerHasAtLeastOneNonHiddenMatchingElement = (
  $container: JQuery,
  selector: string
): boolean =>
  $container.find(selector).filter((_, ht) => $(ht).css("display") !== "none")
    .length > 0;

const countryCodes: { [string: string]: string } = {
  "Hong Kong SAR": "HK",
  "Macau SAR": "MO",
  afghanistan: "AF",
  "aland islands": "AX",
  albania: "AL",
  algeria: "DZ",
  "american samoa": "AS",
  andorra: "AD",
  angola: "AO",
  anguilla: "AI",
  antarctica: "AQ",
  "antigua and barbuda": "AG",
  argentina: "AR",
  armenia: "AM",
  aruba: "AW",
  "asia (unknown country)": "AP",
  australia: "AU",
  austria: "AT",
  azerbaijan: "AZ",
  bahamas: "BS",
  bahrain: "BH",
  bangladesh: "BD",
  barbados: "BB",
  belarus: "BY",
  belgium: "BE",
  belize: "BZ",
  benin: "BJ",
  bermuda: "BM",
  bhutan: "BT",
  bolivia: "BO",
  "bonaire/sint eustatius/saba": "BQ",
  "bosnia and herzegowina": "BA",
  botswana: "BW",
  "bouvet island": "BV",
  brazil: "BR",
  "british indian ocean territory": "IO",
  "british virgin islands": "VG",
  "brunei darussalam": "BN",
  bulgaria: "BG",
  "burkina faso": "BF",
  burundi: "BI",
  cambodia: "KH",
  cameroon: "CM",
  canada: "CA",
  "cape verde": "CV",
  "cayman islands": "KY",
  "central african republic": "CF",
  chad: "TD",
  chile: "CL",
  china: "CN",
  "christmas island": "CX",
  "cocos (keeling) islands": "CC",
  colombia: "CO",
  comoros: "KM",
  congo: "CG",
  "cook islands": "CK",
  "costa rica": "CR",
  "cote d ivoire": "CI",
  croatia: "HR",
  cuba: "CU",
  curacao: "CW",
  cyprus: "CY",
  "czech republic": "CZ",
  "democratic republic of the congo": "CD",
  denmark: "DK",
  djibouti: "DJ",
  dominica: "DM",
  "dominican republic": "DO",
  ecuador: "EC",
  egypt: "EG",
  "el salvador": "SV",
  "equatorial guinea": "GQ",
  eritrea: "ER",
  estonia: "EE",
  ethiopia: "ET",
  "europe (unknown country)": "EU",
  "falkland islands (malvinas)": "FK",
  "faroe islands": "FO",
  "federated states of micronesia": "FM",
  fiji: "FJ",
  finland: "FI",
  france: "FR",
  "french guiana": "GF",
  "french polynesia": "PF",
  "french southern territories": "TF",
  gabon: "GA",
  gambia: "GM",
  georgia: "GE",
  germany: "DE",
  ghana: "GH",
  gibraltar: "GI",
  greece: "GR",
  greenland: "GL",
  grenada: "GD",
  guadeloupe: "GP",
  guam: "GU",
  guatemala: "GT",
  guernsey: "GG",
  guinea: "GN",
  "guinea-bissau": "GW",
  guyana: "GY",
  haiti: "HT",
  "heard and mc donald islands": "HM",
  "holy see (vatican city state)": "VA",
  honduras: "HN",
  hungary: "HU",
  iceland: "IS",
  india: "IN",
  indonesia: "ID",
  "iran (islamic republic of)": "IR",
  iraq: "IQ",
  ireland: "IE",
  "isle of man": "IM",
  israel: "IL",
  italy: "IT",
  jamaica: "JM",
  japan: "JP",
  jersey: "JE",
  jordan: "JO",
  kazakhstan: "KZ",
  kenya: "KE",
  kiribati: "KI",
  kuwait: "KW",
  kyrgyzstan: "KG",
  "lao peoples democratic republic": "LA",
  latvia: "LV",
  lebanon: "LB",
  lesotho: "LS",
  liberia: "LR",
  "libyan arab jamahiriya": "LY",
  liechtenstein: "LI",
  lithuania: "LT",
  luxembourg: "LU",
  macedonia: "MK",
  madagascar: "MG",
  malawi: "MW",
  malaysia: "MY",
  maldives: "MV",
  mali: "ML",
  malta: "MT",
  "marshall islands": "MH",
  martinique: "MQ",
  mauritania: "MR",
  mauritius: "MU",
  mayotte: "YT",
  mexico: "MX",
  moldova: "MD",
  monaco: "MC",
  mongolia: "MN",
  montenegro: "ME",
  montserrat: "MS",
  morocco: "MA",
  mozambique: "MZ",
  myanmar: "MM",
  namibia: "NA",
  nauru: "NR",
  nepal: "NP",
  netherlands: "NL",
  "netherlands antilles": "AN",
  "new caledonia": "NC",
  "new zealand": "NZ",
  nicaragua: "NI",
  niger: "NE",
  nigeria: "NG",
  niue: "NU",
  "norfolk island": "NF",
  "north korea": "KP",
  "northern mariana islands": "MP",
  norway: "NO",
  oman: "OM",
  pakistan: "PK",
  palau: "PW",
  "palestinian territories": "PS",
  panama: "PA",
  "papua new guinea": "PG",
  paraguay: "PY",
  peru: "PE",
  philippines: "PH",
  pitcairn: "PN",
  poland: "PL",
  portugal: "PT",
  "puerto rico": "PR",
  qatar: "QA",
  reunion: "RE",
  romania: "RO",
  "russian federation": "RU",
  rwanda: "RW",
  "saint barthelemy": "BL",
  "saint kitts and nevis": "KN",
  "saint lucia": "LC",
  "saint martin": "MF",
  "saint vincent and the grenadines": "VC",
  samoa: "WS",
  "san marino": "SM",
  "sao tome and principe": "ST",
  "saudi arabia": "SA",
  senegal: "SN",
  serbia: "RS",
  seychelles: "SC",
  "sierra leone": "SL",
  singapore: "SG",
  "sint maarten": "SX",
  "slovakia (slovak republic)": "SK",
  slovenia: "SI",
  "solomon islands": "SB",
  somalia: "SO",
  "south africa": "ZA",
  "south georgia / south sandwich isl": "GS",
  "south korea": "KR",
  "south sudan": "SS",
  spain: "ES",
  "sri lanka": "LK",
  "st. helena": "SH",
  "st. pierre and miquelon": "PM",
  sudan: "SD",
  suriname: "SR",
  "svalbard and jan mayen islands": "SJ",
  swaziland: "SZ",
  sweden: "SE",
  switzerland: "CH",
  "syrian arab republic": "SY",
  "taiwan province of china": "TW",
  tajikistan: "TJ",
  tanzania: "TZ",
  thailand: "TH",
  "timor-leste": "TL",
  togo: "TG",
  tokelau: "TK",
  tonga: "TO",
  "trinidad and tobago": "TT",
  tunisia: "TN",
  turkiye: "TR",
  turkmenistan: "TM",
  "turks and caicos islands": "TC",
  tuvalu: "TV",
  uganda: "UG",
  ukraine: "UA",
  "united arab emirates": "AE",
  "united kingdom": "GB",
  "united states": "US",
  uruguay: "UY",
  "us minor outlying islands": "UM",
  "us virgin islands": "VI",
  usa: "US",
  uzbekistan: "UZ",
  vanuatu: "VU",
  venezuela: "VE",
  "viet nam": "VN",
  "wallis and futuna islands": "WF",
  "western sahara": "EH",
  yemen: "YE",
  zambia: "ZM",
  zimbabwe: "ZW",
};

const LeadFormSharedComponent = (props: LeadFormSharedComponentProps): JSX.Element => {
  const { fromFloatingContactOptions, leadFormData } = props;

  const {
    // componentclass,
    // hideLeadform,
    // useRedesignStyle,
    // pTandc,
    emailDomainBlocklist,
    leadFormIsCtaLeadForm,
    leadFormIsNewNet,
    leadFormIsTwoStep,
    leadFormSettings,
    pFormLegalRewrittenMinified,
    pInstructions,
    pSelectEloquaFormContentUnescapeJava,
    pSubmitButtonText,
    pTitle,
    xForwardedForFirstElement,
  } = leadFormData;

  // TODO
  const leadFormSettingsAny: any = leadFormSettings;

  // TODO
  const leadFormSettingsLeadFormSettings: LeadFormSettings =
    leadFormSettingsAny;

  const pFormLegal = pFormLegalRewrittenMinified;

  const leadFormIdentifierWrapperReference = useRef<HTMLDivElement>(null);

  /**
   * Get leadFormIdentifierWrapper
   *
   * @returns jQuery object for childSelector within the lead form container
   */
  const getLeadFormIdentifierWrapper = (): JQuery =>
    $(leadFormIdentifierWrapperReference.current!);

  /**
   * Convert global selector to selector within lead form
   *
   * @param childSelector - CSS selector
   * @returns jQuery object for childSelector within the lead form container
   */
  const containerizeSelector = (childSelector: string): JQuery =>
    getLeadFormIdentifierWrapper().find(childSelector);

  const getLeadFormNextButton = (): JQuery =>
    containerizeSelector(".leadFormNextButton");

  const getLeadFormSubmitButton = (): JQuery =>
    containerizeSelector(".leadFormSubmitButton");

  const getThankYouMessage = (): JQuery =>
    containerizeSelector(".thank-you-msg");

  const getTermsConditions = (): JQuery =>
    containerizeSelector(".terms-conditions");

  const getLegal = (): JQuery => containerizeSelector(".legal");

  const getForm = (): JQuery =>
    containerizeSelector(".leadFormFormWrapper form");

  const setGUIDVisitorID = () => {
    const $form = getForm();

    const hidCookie = dnbGetCookie(hidCookieName);
    const mktoTrkCookie = dnbGetCookie("_mkto_trk");

    if (
      isNotUndefined(hidCookie) &&
      hidCookie.length > 0 &&
      hidCookie !== "null"
    ) {
      $form
        .find('input[name="_mkt_trk"]')
        .val(isNotUndefined(mktoTrkCookie) ? mktoTrkCookie : "");
      $form.find('input[name="Visitor_ID__c"]').val(hidCookie);
    } else {
      const today = new window.Date();
      const cookie_value = today.getTime();

      createCookie(hidCookieName, cookie_value, 30);

      const _hidCookie = dnbGetCookie(hidCookieName);

      $form
        .find('input[name="Visitor_ID__c"]')
        .val(isNotUndefined(_hidCookie) ? _hidCookie : "");
    }
  };

  const setCreativeID = () => {
    const $form = getForm();

    const splitFirstElement = window.document.URL.split("?")[0]!;

    $form.find('input[name="Hoov_CreativeID__c"]').val(splitFirstElement);

    const $formInputNameMktoReferrer = $form.find(
      'input[name="_mktoReferrer"]'
    );

    $formInputNameMktoReferrer.val(splitFirstElement);
  };

  const setVisitFromDate = () => {
    const $form = getForm();

    const currentDate = new window.Date();
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    const hours = currentDate.getHours();
    const minutes = currentDate.getMinutes();
    const seconds = currentDate.getSeconds();

    const timestamp = `${window.String(year)}-${window.String(
      month
    )}-${window.String(day)}T${window.String(hours)}:${window.String(
      minutes
    )}:${window.String(seconds)}`;

    $form.find('input[name="Visitor_From_Date__c"]').val(timestamp);
    $form.find('input[name="Form_Submit_Timestamp__c"]').val(timestamp);
  };

  /**
   * @param arrayOfIds - IDs of elements to check
   * @returns false if none of the specified elements have been set, true if at least one has been set
   */
  const anyElementWithIdInArraySet = (arrayOfIds: string[]): boolean => {
    for (const id of arrayOfIds) {
      const value = containerizeSelector(`[id="${id}"]`).val();

      if (typeof value === "string" && value.length > 0) {
        return true;
      }
    }

    return false;
  };

  useEffect(() => {
    $(() => {
    //   if (isNotUndefined(hideLeadform) && hideLeadform.length > 0) {
    //     return;
    //   }

      const unmatchedVisitor = "Unmatched Visitor";

      const wAddressCookieName = "w_addressAddress";
      const wBusPhoneCookieName = "w_busPhone";
      const wCompanyNameCookieName = "w_companyName";
      const wEmailAddressCookieName = "w_emailAddress";
      const wFirstNameCookieName = "w_firstName";
      const wLastNameCookieName = "w_lastName";
      const wTitleCookieName = "w_title";
      const wZipPostalCookieName = "w_zipPostal";

      const isTwoStep = leadFormIsTwoStep;
      const isCtaLeadForm = leadFormIsCtaLeadForm;

    //   const useRedesignStyleBoolean = useRedesignStyle === "true";

      const focusFormFirstname = !isCtaLeadForm;

      let showingLastStepGlobal = false;

      const showOrHideCommentC = ($form: JQuery) => {
        const showCommentC = getEleadsProductInterestC($form).val() === "Other";

        getCommentC($form).toggle(showCommentC && showingLastStepGlobal);
      };

      const languageToUse = getLanguageToUse([
        leadFormSettingsLeadFormSettings.locale,
        leadFormSettingsLeadFormSettings.preferredLanguage,
      ]);

      const marketoFormWrapper = getMarketoFormWrapper();

      /**
       * Update interface based on which step we are on
       *
       * @param showFirstStep - true if first step, false if second step
       */
      const showFirstStepIfTrueSecondStepIfFalse = (showFirstStep: boolean) => {
        // Only show if on first step of two step
        const showNextButton = isTwoStep && showFirstStep;

        // Show on only step of one step or second step of two step
        const showingLastStep = !isTwoStep || !showFirstStep;

        const $form = getForm();

        $form.find("> .row > div > label > *").each((_, ht) => {
          $(ht).toggle(showingLastStep);
        });

        // Always show email
        showIfTrueHideIfFalseWithSiblingsInLabel(
          containerizeSelector('[id="form-custservsubmitemail"]'),
          true
        );

        showIfTrueHideIfFalseWithSiblingsInLabel(
          getLeadFormNextButton(),
          showNextButton
        );
        showIfTrueHideIfFalseWithSiblingsInLabel(
          getLeadFormSubmitButton(),
          showingLastStep
        );

        // Special cases
        showIfTrueHideIfFalseWithSiblingsInLabel(
          getTermsConditions(),
          showingLastStep
        );
        showIfTrueHideIfFalseWithSiblingsInLabel(getLegal(), showingLastStep);

        // Hide title and subtitle from component lead forms
        showIfTrueHideIfFalseWithSiblingsInLabel(
          containerizeSelector(".leadFormTitleAndSubtitleRow"),
          isCtaLeadForm 
        //   || useRedesignStyleBoolean
        );

        showingLastStepGlobal = showingLastStep;

        // DCC-3325
        showOrHideCommentC($form);
        if (leadFormIsNewNet) {
          hideFieldsForNetNewForm($form);
        }

        const $row = $form.find("> .row");
        const $rowDiv = $row.find("> div");

        // Show columns if they have at least one visible child (input or select, probably)
        $rowDiv.each((_, ht) => {
          const $this = $(ht);

          $this.toggle(
            containerHasAtLeastOneNonHiddenMatchingElement($this, "> label > *")
          );
        });

        // Show rows if they have at least one visible column
        $row.each((_, ht) => {
          const $this = $(ht);

          $this.toggle(
            containerHasAtLeastOneNonHiddenMatchingElement($this, "> div")
          );
        });
      };

      /**
       * @returns false if form validation failed, true if form was submitted
       */
      const submitForm = (): boolean => {
        const $form = getForm();

        const windowValidateForm = window["validateForm"];

        const typedWindowValidateForm:
          | ((language: string) => boolean)
          | undefined =
          typeof windowValidateForm === "function"
            ? windowValidateForm
            : void 0;

        // Using a local variable is a hack to fix indent rule violation
        const typedWindowValidateFormWrapper = () => {
          if (isUndefined(typedWindowValidateForm)) {
            dnbComLog(LogSeverity.ERROR, "Error at validating form");
          }

          return typedWindowValidateForm(languageToUse);
        };

        const validateForm = (): boolean => {
          containerizeSelector(`.${formErrorMessageClassName}`).remove();

          let error = false;

          const validateFieldCore = (
            $field: JQuery,
            isFieldInvalid: (
              value: string[] | number | string | undefined
            ) => boolean,
            getErrorMessage: () => string
          ) => {
            if ($field.length > 0) {
              const value = $field.val();
              const fieldIsInvalid = isFieldInvalid(value);

              if (fieldIsInvalid) {
                error = true;
                addError($field, getErrorMessage());
              } else {
                removeError($field);
              }
            } else {
              dnbComLog(
                LogSeverity.WARN,
                new Error(
                  "Could not perform field validation on field because no elements matched the selector"
                )
              );
            }
          };

          const validateField = (
            $field: JQuery,
            isFieldInvalid: (
              value: string[] | number | string | undefined
            ) => boolean,
            errorMessageKey: string
          ) =>
            validateFieldCore($field, isFieldInvalid, () =>
              getLocalizedMessage(errorMessageKey, languageToUse)
            );

          const validateFieldRawErrorMessage = (
            $field: JQuery,
            isFieldInvalid: (
              value: string[] | number | string | undefined
            ) => boolean,
            errorMessage: string
          ) => {
            validateFieldCore($field, isFieldInvalid, () => errorMessage);
          };

          try {
            const $formInputNameFirstName = getFormInputNameFirstName($form);

            validateField(
              $formInputNameFirstName,
              (value) => valToString(value).length === 0,
              "enter-first-name"
            );

            const $formInputNameLastName = getFormInputNameLastName($form);

            validateField(
              $formInputNameLastName,
              (value) => valToString(value).length === 0,
              "enter-last-name"
            );

            // Checking for "emailAddress" might be unnecessary given the check for window["validateForm"]
            const $emailInput = getFormInputNameEmail($form);
            const $emailAddressInput = $form.find('input[name="emailAddress"]');

            let $emailInputToValidate;

            if ($emailInput.length > 0) {
              if ($emailAddressInput.length > 0) {
                dnbComLog(
                  LogSeverity.ERROR,
                  new Error(
                    'Found two email address fields, one with name "Email", one with name "emailAddress". Only validating the "Email" field.'
                  )
                );
              }

              $emailInputToValidate = $emailInput;
            } else if ($emailAddressInput.length > 0) {
              $emailInputToValidate = $emailAddressInput;
            } else {
              dnbComLog(
                LogSeverity.ERROR,
                new Error(
                  "Did not find an email address field, skipping email address validation"
                )
              );

              $emailInputToValidate = void 0;
            }

            if (isNotUndefined($emailInputToValidate)) {
              const emailValidationError = validateEmail($emailInputToValidate);

              if (isNotUndefined(emailValidationError)) {
                validateField(
                  $emailInputToValidate,
                  (_value) => true,
                  emailValidationError
                );
              }
            }

            const $formInputNamePhone = getFormInputNamePhone($form);
            const $formSelectNameCountry = $form.find('select[name="Country"]');

            const formSelectNameCountryVal = $formSelectNameCountry.val();

            if (
              $formInputNamePhone.length > 0 &&
              $formSelectNameCountry.length > 0
            ) {
              const formInputNamePhoneValueString = valToString(
                $formInputNamePhone.val()
              );
              const formSelectNameCountryValueString = valToString(
                formSelectNameCountryVal
              );
              //
              if (formInputNamePhoneValueString.length === 0) {
                validateField(
                  $formInputNamePhone,
                  (_value) => true,
                  "enter-phone"
                );
              } else {
                validateField(
                  $formInputNamePhone,
                  (_value) => {
                    const isCanadaOrUnitedStates =
                      formSelectNameCountryValueString === canadaIsoCode ||
                      formSelectNameCountryValueString === unitedStatesIsoCode;

                    return isCanadaOrUnitedStates
                      ? !canadaUnitedStatesPhoneNumberRegularExpression.test(
                          formInputNamePhoneValueString
                        )
                      : false;
                  },
                  "invalid-phone"
                );
              }
            }

            if (!leadFormIsNewNet) {
              const $formSelectNameTitle = getFormSelectNameTitle($form);

              validateField(
                $formSelectNameTitle,
                (value) => valToString(value).length === 0,
                "select-title"
              );
            }

            const $formSelectNameDepartmentOne = $form.find(
              'select[name="department1"]'
            );

            validateField(
              $formSelectNameDepartmentOne,
              (value) => valToString(value).length === 0,
              "select-department"
            );

            const $formInputNameCompany = $form.find('input[name="Company"]');

            validateField(
              $formInputNameCompany,
              (value) => valToString(value).length === 0,
              "enter-company"
            );

            if (!leadFormIsNewNet) {
              if ($form.find('input[name^="Address"]').val() === "") {
                error = true;
                addError(
                  $form.find('input[name^="Address"]'),
                  getLocalizedMessage("enter-address", languageToUse)
                );
              } else {
                removeError($form.find('input[name^="Address"]'));
              }

              const zipCodeRegularExpression = /^\d{5}(-\d{4})?$/;
              const canadaPostalCodeRegularExpression =
                /^[a-z]\d[a-z][ -]?\d[a-z]\d$/i;

              let postalCodeError: string | undefined = void 0;

              if ($form.find('input[name^="PostalCode"]').val() === "") {
                postalCodeError = "enter-zip";
              } else if (formSelectNameCountryVal === unitedStatesIsoCode) {
                if (
                  valToString(
                    $form.find('input[name^="PostalCode"]').val()
                  ).match(zipCodeRegularExpression) === null
                ) {
                  postalCodeError = "invalid-zip-5digit";
                }
              } else if (formSelectNameCountryVal === canadaIsoCode) {
                if (
                  valToString(
                    $form.find('input[name^="PostalCode"]').val()
                  ).match(canadaPostalCodeRegularExpression) === null
                ) {
                  postalCodeError = "invalid-zip";
                }
              } else if (formSelectNameCountryVal === "GB") {
                if (
                  !isValidUnitedKingdomOrIrelandPostalCode(
                    valToString($form.find('input[name^="PostalCode"]').val()),
                    false
                  )
                ) {
                  postalCodeError = "invalid-zip";
                }
              } else if (
                formSelectNameCountryVal === irelandIsoCode &&
                !isValidUnitedKingdomOrIrelandPostalCode(
                  valToString($form.find('input[name^="PostalCode"]').val()),
                  true
                )
              ) {
                postalCodeError = "invalid-zip";
              }

              if (isUndefined(postalCodeError)) {
                removeError($form.find('input[name^="PostalCode"]'));
              } else {
                error = true;

                addError(
                  $form.find('input[name^="PostalCode"]'),
                  getLocalizedMessage(postalCodeError, languageToUse)
                );
              }
            }

            const dunsNumberRegularExpression = /^\d{9}$/;

            const $formNameDirectDunsCC = $form.find(
              '[name="DirectDUNS_c__c"]'
            );

            validateField(
              $formNameDirectDunsCC,
              (value) => {
                const valueString = valToString(value);

                return (
                  valueString.length > 0 &&
                  !dunsNumberRegularExpression.test(valueString)
                );
              },
              "invalid-duns-9digit"
            );

            validateField(
              $formSelectNameCountry,
              (value) => valToString(value).length === 0,
              "select-country"
            );

            // DCC-3325
            const $commentC = getCommentC($form);
            const $eleadsProductInterestC = getEleadsProductInterestC($form);
            const $mktoFinTestimonialconsent =
              getMktoFinTestimonialconsent($form);
            const $mktoPersonNotes = getMktoPersonNotes($form);

            if (
              $commentC.length > 0 &&
              $eleadsProductInterestC.length > 0 &&
              $mktoFinTestimonialconsent.length > 0 &&
              $mktoPersonNotes.length > 0
            ) {
              validateFieldRawErrorMessage(
                $commentC,
                (value) => {
                  const otherProductSelected =
                    $eleadsProductInterestC.val() === "Other";

                  // Hack to prevent unexpected data from being sent
                  if (!otherProductSelected) {
                    $commentC.val("");
                  }

                  return (
                    otherProductSelected &&
                    (typeof value !== "string" || value.length === 0)
                  );
                },
                "Please enter a product"
              );

              validateFieldRawErrorMessage(
                $eleadsProductInterestC,
                (value) => typeof value !== "string" || value.length === 0,
                "Please select a product"
              );

              validateFieldRawErrorMessage(
                $mktoFinTestimonialconsent,
                (_) => !$mktoFinTestimonialconsent.is(":checked"),
                "You must accept the Consent Terms in order to proceed"
              );

              validateFieldRawErrorMessage(
                $mktoPersonNotes,
                (value) => typeof value !== "string" || value.length === 0,
                "Please provide a testimonial"
              );
            }

            return !error;
          } catch (er) {
            dnbComLog(LogSeverity.ERROR, er);

            return false;
          }
        };

        const validateFormFunctionToUse = isNotUndefined(
          typedWindowValidateForm
        )
          ? typedWindowValidateFormWrapper
          : validateForm;

        if (!validateFormFunctionToUse()) {
          dnbComLog(LogSeverity.INFO, "validateForm returned false");

          // Revalidate the form after any change is made to form input elements
          $form.find(":input").on("change", () => {
            validateFormFunctionToUse();
          });

          return false;
        }

        const windowDigitalData = getWindowDigitalData();

        const contentId = windowDigitalData?.page.pageInfo.contentID;

        const marketingCookiesAreEnabled = trustArcGroupIsActive(
          TrustArcGroupId.trustArcGroupThree
        );

        // TODO Logic is no longer valid, after Bisnode sites were added
        // Canada, Ireland, United Kingdom
        const pageIsNonCaIeUk =
          isNotUndefined(contentId) &&
          !(
            contentId.includes("/dnb-ca") ||
            contentId.includes("/dnb-ie") ||
            contentId.includes("/dnb-uk")
          );

        if (marketingCookiesAreEnabled || pageIsNonCaIeUk) {
          const setReturnVisitorValues = () => {
            const durationInDays = 30;

            const setCookieIfValueIsValid = (
              cookieName: string,
              value: any
            ) => {
              if (isUndefinedOrNull(value)) {
                dnbComLog(
                  LogSeverity.WARN,
                  `undefined or null value passed to "setCookieIfValueIsValid" when setting cookie "${cookieName}"`
                );
              } else if (value.length > 0) {
                if (typeof value !== "string") {
                  dnbComLog(
                    LogSeverity.ERROR,
                    `Non-string value passed to "setCookieIfValueIsValid" when setting cookie "${cookieName}"`
                  );
                }

                const valueString =
                  typeof value === "string" ? value : window.String(value);

                createCookie(cookieName, valueString, durationInDays);
              }
            };

            const setCookieIfFieldExistsAndHasValidValue = (
              $field: JQuery,
              cookieName: string
            ) => {
              const fieldLength = $field.length;

              if (fieldLength > 0) {
                if (fieldLength > 1) {
                  dnbComLog(
                    LogSeverity.WARN,
                    `More than one matching element was found while setting cookie "${cookieName}"`
                  );
                }

                setCookieIfValueIsValid(cookieName, $field.val());
              } else {
                dnbComLog(
                  LogSeverity.WARN,
                  `No matching elements were found when attempting to set cookie "${cookieName}"`
                );
              }
            };

            // Set form values to cookie for return visits
            const $formInputNameFirstName = getFormInputNameFirstName($form);
            setCookieIfFieldExistsAndHasValidValue(
              $formInputNameFirstName,
              wFirstNameCookieName
            );

            const $formInputNameLastName = getFormInputNameLastName($form);
            setCookieIfFieldExistsAndHasValidValue(
              $formInputNameLastName,
              wLastNameCookieName
            );

            const $formInputNameEmail = getFormInputNameEmail($form);
            setCookieIfFieldExistsAndHasValidValue(
              $formInputNameEmail,
              wEmailAddressCookieName
            );

            const $formInputNameCompany = $form.find('input[name="Company"]');
            setCookieIfFieldExistsAndHasValidValue(
              $formInputNameCompany,
              wCompanyNameCookieName
            );

            const $formInputNamePostalCode = $form.find(
              'input[name="PostalCode"]'
            );
            setCookieIfFieldExistsAndHasValidValue(
              $formInputNamePostalCode,
              wZipPostalCookieName
            );

            // Select, not input
            const $formSelectNameTitle = getFormSelectNameTitle($form);
            setCookieIfFieldExistsAndHasValidValue(
              $formSelectNameTitle,
              wTitleCookieName
            );

            if ($form.find('input[name^="Address"]').val() !== "") {
              setCookieIfValueIsValid(
                wAddressCookieName,
                $form.find('input[name="Address"]').val()
              );
            }

            const $formInputNamePhone = getFormInputNamePhone($form);
            setCookieIfFieldExistsAndHasValidValue(
              $formInputNamePhone,
              wBusPhoneCookieName
            );
          };

          setReturnVisitorValues();
        }

        // Duplicate hidden input elements are causing the first value sent to be empty
        const formNamesToRemoveDuplicates = [
          "formid",
          "formVid",
          "munchkinId",
          "Warm_Transfer_Name__c",
        ];

        // DataLayer.push({
        //     "event": "marketo.success",
        //     "marketo.form_id": form_id,
        //     "marketo.form_values": values,
        //     "marketo.follow_up_url": followUpUrl,
        //     "eventCallback": function () {
        //       Document.location.href = followUpUrl;
        //     }
        //   });

        try {
          getWindowUnderscoreSatellite().track("formSubmit-test");
        } catch (er) {
          dnbComLog(LogSeverity.ERROR, er);
        }

        try {
          getWindowBizible().Push("Form", $form);
        } catch (er) {
          dnbComLog(LogSeverity.ERROR, er);
        }

        const formJquerySerializeArrayElementArray = $form.serializeArray();

        const formJquerySerializeArrayElementArrayDuplicateFormEntriesRemoved =
          removeDuplicateFormEntries(
            formJquerySerializeArrayElementArray,
            formNamesToRemoveDuplicates
          );

        const hiddenFieldsObject: { [string: string]: string } = {};

        // Converting array of name and value objects to object with name keys and value values
        for (const jquerySerializeArrayElement of formJquerySerializeArrayElementArrayDuplicateFormEntriesRemoved) {
          hiddenFieldsObject[jquerySerializeArrayElement.name] =
            jquerySerializeArrayElement.value;
        }

        marketoFormWrapper.addMarketoFormLoadCallback((marketoForm) => {
          marketoForm.addHiddenFields(hiddenFieldsObject);

          const allFormValidatorsPassed = marketoForm.validate();

          if (typeof allFormValidatorsPassed !== "boolean") {
            dnbComLog(LogSeverity.ERROR, "Marketo form validation failed");
          }

          if (allFormValidatorsPassed) {
            const eloquasubmitId = "eloquasubmit";

            const $eloquasubmit = containerizeSelector(`#${eloquasubmitId}`);

            if ($eloquasubmit.length > 0) {
              if ($eloquasubmit.length > 1) {
                dnbComLog(
                  LogSeverity.WARN,
                  `Extra elements with ID "${eloquasubmitId}" were found`
                );
              }

              // This is a hack intended to make the form submission wait until the analytics event handler has finished
              // Otherwise, the browser may be navigated to a different page before the analytics code has run
              $eloquasubmit.on("click", (_eventObject) => {
                marketoForm.submit();
              });

              $eloquasubmit.first().trigger("click");
            } else {
              dnbComLog(
                LogSeverity.ERROR,
                `No element with ID "${eloquasubmitId}" was found. Analytics will be affected.`
              );

              marketoForm.submit();
            }
          } else {
            dnbComLog(
              LogSeverity.ERROR,
              "Custom form validation passed but Marketo form validation failed. The form was not submitted, but this may not be clear to the user."
            );
          }
        });

        return true;
      };

      const setMisc = () => {
        const windowDigitalData = getWindowDigitalData();

        ifExistsSetValue(
          containerizeSelector('input[name="Visitor_From__c"]'),
          () => getVisitorFrom()
        );

        ifExistsSetValue(
          containerizeSelector('input[name="Site_Origin__c"]'),
          () => leadFormSettingsLeadFormSettings.siteOrigin
        );

        ifExistsSetValue(
          containerizeSelector('input[name="eLeads_Product_Interest__c"]'),
          () => leadFormSettingsLeadFormSettings.productInterest
        );

        ifExistsSetValue(
          containerizeSelector('input[name="elqCampaignId"]'),
          () => leadFormSettingsLeadFormSettings.eloquaCampaignId
        );

        ifExistsSetValue(
          containerizeSelector('input[name="Lead_Priority__c"]'),
          () => leadFormSettingsLeadFormSettings.leadPriority
        );

        ifExistsSetValue(
          containerizeSelector(
            'input[name="Webvisitor_Number_of_Employees__c"]'
          ),
          () =>
            // @ts-expect-error Ignore
            windowDigitalData?.page?.clientContext["employeesInAllLocations"]
        );

        ifExistsSetValue(
          containerizeSelector(
            'input[name="Webvisitor_Domestic_Ultimate_DUNS__c"]'
          ),
          () =>
            // @ts-expect-error Ignore
            windowDigitalData?.page?.clientContext["domesticUltimateDuns"]
        );

        ifExistsSetValue(
          containerizeSelector('input[name="Webvisitor_Annual_Sales__c"]'),
          () =>
            // @ts-expect-error Ignore
            windowDigitalData?.page?.clientContext["annualSalesNum"]
        );

        ifExistsSetValue(
          containerizeSelector('input[name="Webvisitor_DUNS__c"]'),
          () => windowDigitalData?.page?.clientContext.DUNSNumber
        );

        ifExistsSetValue(
          containerizeSelector('input[name="Partner_Name__c"]'),
          () => leadFormSettingsLeadFormSettings.partnerName1
        );

        setFieldValueIfExistsAndValueIsNotEmpty(
          containerizeSelector('input[name="formType"]'),
          leadFormSettingsLeadFormSettings.formtype
        );
        setFieldValueIfExistsAndValueIsNotEmpty(
          containerizeSelector('input[name="Last_Campaign_Name__c"]'),
          leadFormSettingsLeadFormSettings.sFDCLastCampaignName
        );
        // @ts-expect-error Ignore
        setFieldValueIfExistsAndValueIsNotEmpty(
          containerizeSelector('[id="eloqua-form-subtitle"]'),
          leadFormSettingsLeadFormSettings["subTitle"]
        );

        const $inputNamePreferredLanguageOne = containerizeSelector(
          'input[name="preferredLanguage1"]'
        );

        if ($inputNamePreferredLanguageOne.length > 0) {
          let preferredLanguageOneToUse: string | undefined;

          if (leadFormSettingsLeadFormSettings.preferredLanguage === "en") {
            preferredLanguageOneToUse = "ENGLISH";
          } else if (
            leadFormSettingsLeadFormSettings.preferredLanguage === "fr"
          ) {
            preferredLanguageOneToUse = "FRENCH";
          } else {
            dnbComLog(
              LogSeverity.ERROR,
              new Error(
                `Could not determine "preferredLanguage1" from leadFormSettings property preferredLanguage value "${leadFormSettingsLeadFormSettings.preferredLanguage}"`
              )
            );

            preferredLanguageOneToUse = void 0;
          }

          if (isNotUndefined(preferredLanguageOneToUse)) {
            $inputNamePreferredLanguageOne.val(preferredLanguageOneToUse);
          }
        }

        if (leadFormSettingsLeadFormSettings.sFDCLastCampaignID.length > 0) {
          containerizeSelector('input[name="Campaign_ID__c"]').val(
            leadFormSettingsLeadFormSettings.sFDCLastCampaignID
          );

          const ifExistsSetToSFdcLastCampaignId = ($field: JQuery) => {
            if ($field.length > 0) {
              $field.val(leadFormSettingsLeadFormSettings.sFDCLastCampaignID);
            }
          };

          // Meant for UK
          ifExistsSetToSFdcLastCampaignId(
            containerizeSelector('input[name="CampaignID__c"]')
          );

          // Marketo requirement
          ifExistsSetToSFdcLastCampaignId(
            containerizeSelector('input[name="campaign_id_c"]')
          );

          // Marketo requirement
          ifExistsSetToSFdcLastCampaignId(
            containerizeSelector('input[name="campaign_c"]')
          );
          ifExistsSetToSFdcLastCampaignId(
            containerizeSelector('input[name="Campaign__c"]')
          );
        }

        //    If(containerizeSelector("input[name=\"uNDUNSdToLDR1\"]").length)
        //		ContainerizeSelector("input[name=\"uNDUNSdToLDR1\"]").val(leadformSettings.uNDUNSdToLDR1);

        ifFirstFieldExistsSetBothFields(
          containerizeSelector('input[name="Solution_Interest__c"]'),
          containerizeSelector('input[name="Solution_Interest__c_contact"]'),
          leadFormSettingsLeadFormSettings.solutionInterest
        );

        ifFirstFieldExistsSetBothFields(
          containerizeSelector('input[name="Lead_Type__c"]'),
          containerizeSelector('input[name="Lead_Type_Original__c"]'),
          leadFormSettingsLeadFormSettings.leadType
        );
        ifFirstFieldExistsSetBothFields(
          containerizeSelector('input[name="LeadSource"]'),
          containerizeSelector('input[name="Lead_Source_Original__c"]'),
          leadFormSettingsLeadFormSettings.leadSource
        );
        ifFirstFieldExistsSetBothFields(
          containerizeSelector('input[name="Last_Campaign_Name__c"]'),
          containerizeSelector('input[name="Campaign_Name__c"]'),
          leadFormSettingsLeadFormSettings.sFDCLastCampaignName
        );

        //	If(containerizeSelector("input[name=\"manualReviewFlag1\"]").length)
        //		ContainerizeSelector("input[name=\"manualReviewFlag1\"]").val(leadformSettings.manualReviewFlag1);

        //	If(containerizeSelector("input[name=\"dialerEligiblePage1\"]").length)
        //		ContainerizeSelector("input[name=\"dialerEligiblePage1\"]").val(leadformSettings.dialerEligiblePage1);

        const $thankYouMessage = getThankYouMessage();

        $thankYouMessage.hide();

        if (
          $thankYouMessage.length > 0 &&
          leadFormSettingsLeadFormSettings.thankyouMessage.length > 0
        ) {
          $thankYouMessage.text(
            leadFormSettingsLeadFormSettings.thankyouMessage
          );
        }

        if (
          getLeadFormSubmitButton().length > 0 &&
          leadFormSettingsLeadFormSettings.submitButtonText.length > 0
        ) {
          getLeadFormSubmitButton().attr(
            "value",
            leadFormSettingsLeadFormSettings.submitButtonText
          );
        }

        const $idLegalText = containerizeSelector('[id="legal-text"]');

        if (
          $idLegalText.length > 0 &&
          leadFormSettingsLeadFormSettings.legalText.length > 0
        ) {
          $idLegalText.text(leadFormSettingsLeadFormSettings.legalText);
        }

        const $inputNameMarketingAgreementStatusOne = containerizeSelector(
          'input[name="marketingAgreementStatus1"]'
        );

        if (
          $inputNameMarketingAgreementStatusOne.length > 0 &&
          leadFormSettingsLeadFormSettings.termsconditions.length > 0
        ) {
          // When user agrees to terms & conditions this value is sent
          $inputNameMarketingAgreementStatusOne.val("T&C Received");
        }

        const elqCampaignIdParameterValue = getParameterByName("elqCampaignId");

        const $inputNameCampaignIdC = containerizeSelector(
          'input[name="Campaign_ID__c"]'
        );

        if (
          elqCampaignIdParameterValue.length > 0 &&
          $inputNameCampaignIdC.length > 0
        ) {
          $inputNameCampaignIdC.val(elqCampaignIdParameterValue);

          const ifExistsSetToElqCampaignId = ($field: JQuery) => {
            if ($field.length > 0) {
              $field.val(elqCampaignIdParameterValue);
            }
          };

          // Meant for UK
          ifExistsSetToElqCampaignId(
            containerizeSelector('input[name="CampaignID__c"]')
          );

          // Marketo requirement
          ifExistsSetToElqCampaignId(
            containerizeSelector('input[name="campaign_id_c"]')
          );

          // Marketo requirement
          ifExistsSetToElqCampaignId(
            containerizeSelector('input[name="campaign_c"]')
          );
          ifExistsSetToElqCampaignId(
            containerizeSelector('input[name="Campaign__c"]')
          );
        }

        const copyParameterToField = (
          parameterName: string,
          fieldName: string
        ) => {
          const parameterValue = getParameterByName(parameterName);

          const $fieldName = containerizeSelector(`input[name="${fieldName}"]`);

          if (parameterValue.length > 0 && $fieldName.length > 0) {
            $fieldName.val(parameterValue);
          }
        };

        copyParameterToField("utm_campaign", "utm_campaign__c");
        copyParameterToField("utm_medium", "utm_medium__c");
        copyParameterToField("utm_source", "utm_source__c");
        copyParameterToField("utm_content", "utm_content__c");
        copyParameterToField("utm_term", "utm_term__c");

        const gclidCookie = dnbGetCookie("gclid");

        if (
          isNotUndefined(gclidCookie) &&
          gclidCookie.length > 0 &&
          gclidCookie !== "null"
        ) {
          containerizeSelector('input[name="GCLID__c"]').val(gclidCookie);
        }
      };

      const setFormFromContext = () => {
        const $form = getForm();

        // If Web Visitor values have been set then pre-set the form values

        const populateFieldFromCookie = (
          $field: JQuery,
          cookieName: string
        ) => {
          const cookieValue = getNonEmptyCookieValueOrUndefined(cookieName);

          if (isNotUndefined(cookieValue)) {
            $field.val(cookieValue);
          }
        };

        const $formInputNameFirstName = getFormInputNameFirstName($form);
        populateFieldFromCookie($formInputNameFirstName, wFirstNameCookieName);

        const $formInputNameLastName = getFormInputNameLastName($form);
        populateFieldFromCookie($formInputNameLastName, wLastNameCookieName);

        const $formInputNameEmail = getFormInputNameEmail($form);
        populateFieldFromCookie($formInputNameEmail, wEmailAddressCookieName);

        // Select, not input
        const $formSelectNameTitle = getFormSelectNameTitle($form);
        populateFieldFromCookie($formSelectNameTitle, wTitleCookieName);

        const $formInputNamePhone = getFormInputNamePhone($form);
        populateFieldFromCookie($formInputNamePhone, wBusPhoneCookieName);

        const windowDigitalData = getWindowDigitalData();

        const notUndefinedEmptyOrUnmatchedVisitorOtherwiseUndefined = (
          input: string | undefined,
          action: (input: string) => void
        ): boolean => {
          if (
            isNotUndefined(input) &&
            input.length > 0 &&
            input !== unmatchedVisitor
          ) {
            action(input);

            return true;
          }

          return false;
        };

        const clientContext = windowDigitalData?.page?.clientContext;

        notUndefinedEmptyOrUnmatchedVisitorOtherwiseUndefined(
          clientContext?.companyName,
          (input) => {
            containerizeSelector('[id="form-companyname"]').val(input);
            containerizeSelector('[id="Company"]').val(input);
          }
        );

        notUndefinedEmptyOrUnmatchedVisitorOtherwiseUndefined(
          clientContext?.companyAddress,
          (input) => {
            containerizeSelector('[id="form-address"]').val(input);
          }
        );

        const $idFormPostalcode = containerizeSelector(
          '[id="form-postalcode"]'
        );

        if (
          notUndefinedEmptyOrUnmatchedVisitorOtherwiseUndefined(
            clientContext?.companyZip,
            (input) => {
              $idFormPostalcode.val(input);
            }
          )
        ) {
          // Already set the value in the action
        } else {
          const windowLocationZip = window["location_zip"];

          if (
            isNotUndefined(windowLocationZip) &&
            isNotUndefinedOrNull(windowLocationZip)
          ) {
            $idFormPostalcode.val(windowLocationZip);
          }
        }

        let countryCodesKey;

        if (
          notUndefinedEmptyOrUnmatchedVisitorOtherwiseUndefined(
            clientContext?.location,
            (input) => {
              countryCodesKey = input.toLowerCase();
            }
          )
        ) {
          // Already set the value in the action
        } else {
          const windowLocationCountry = window["location_country"];

          if (
            isNotUndefined(windowLocationCountry) &&
            isNotUndefinedOrNull(windowLocationCountry) &&
            windowLocationCountry !== unmatchedVisitor
          ) {
            countryCodesKey = window
              .String(windowLocationCountry)
              .toLowerCase();
          }
        }

        const $formCountry = containerizeSelector('[id="form-country"]');

        if (isNotUndefined(countryCodesKey)) {
          $formCountry.val(countryCodes[countryCodesKey]!);
        }

        const $inputNameWebvisitorNumberOfEmployeesC = containerizeSelector(
          'input[name="Webvisitor_Number_of_Employees__c"]'
        );

        // @ts-expect-error Ignore
        const employeesInAllLocations =
          clientContext?.["employeesInAllLocations"];

        if (
          $inputNameWebvisitorNumberOfEmployeesC.length > 0 &&
          employeesInAllLocations !== unmatchedVisitor
        ) {
          $inputNameWebvisitorNumberOfEmployeesC.val(employeesInAllLocations);
        }

        const $inputNameWebvisitorDomesticUltimateDunsC = containerizeSelector(
          'input[name="Webvisitor_Domestic_Ultimate_DUNS__c"]'
        );

        // @ts-expect-error Ignore
        const domesticUltimateDuns = clientContext?.["domesticUltimateDuns"];

        if (
          $inputNameWebvisitorDomesticUltimateDunsC.length > 0 &&
          domesticUltimateDuns !== unmatchedVisitor
        ) {
          $inputNameWebvisitorDomesticUltimateDunsC.val(domesticUltimateDuns);
        }

        const $inputNameWebvisitorAnnualSalesC = containerizeSelector(
          'input[name="Webvisitor_Annual_Sales__c"]'
        );

        // @ts-expect-error Ignore
        const annualSalesNumber = clientContext?.["annualSalesNum"];

        if (
          $inputNameWebvisitorAnnualSalesC.length > 0 &&
          annualSalesNumber !== unmatchedVisitor
        ) {
          $inputNameWebvisitorAnnualSalesC.val(annualSalesNumber);
        }

        const $inputNameWebvisitorDunsC = containerizeSelector(
          'input[name="Webvisitor_DUNS__c"]'
        );

        if ($inputNameWebvisitorDunsC.length > 0) {
          notUndefinedEmptyOrUnmatchedVisitorOtherwiseUndefined(
            clientContext?.DUNSNumber,
            (input) => {
              $inputNameWebvisitorDunsC.val(input);
            }
          );
        }

        const hNinemcCookie = dnbGetCookie("h9mc");

        if (
          isNotUndefined(hNinemcCookie) &&
          hNinemcCookie.length > 0 &&
          hNinemcCookie !== "null"
        ) {
          $form.find('input[name="utm_campaign__c"]').val(hNinemcCookie);
        }

        const $inputNamePaidC = containerizeSelector('input[name="paid__c"]');

        if ($inputNamePaidC.length > 0) {
          windowOnLoadOrImmediate($(window), () => {
            let marketingCloudVisitorId;

            try {
              marketingCloudVisitorId =
                getWindowS()?.visitor?.getMarketingCloudVisitorID();
            } catch (er) {
              dnbComLog(LogSeverity.ERROR, er);

              return;
            }

            $inputNamePaidC.val(marketingCloudVisitorId);
          });
        }
      };

      const setupLeadForm = () => {
        const $leadFormIdentifierWrapper = getLeadFormIdentifierWrapper();

        $leadFormIdentifierWrapper.addClass("old-style")
        //   useRedesignStyle === "true" ? "redesign-style" : "old-style"
        // );

        const $form = getForm();

        const $formInputSelectTextarea = $form
          .find(".row > div > *")
          .filter("input, select, textarea")
          .not('input[type="hidden"]')
          .not('input[type="submit"]');

        $formInputSelectTextarea.each((_, ht) => {
          const $element = $(ht);

          const id = $element.attr("id");

          const labelTextOrUndefined = [
            $element.attr("placeholder"),
            $element.attr("aria-label"),
            $element.attr("name"),
          ].find((st) => typeof st === "string" && st.length > 0);

          const $label = $(`<label for=${id}></label`).addClass(
            "lead-form-label"
          );

          $element.before($label);

          $label.append(
            $("<div></div>")
              .addClass("lead-form-label-div")
              .text(
                isUndefined(labelTextOrUndefined) ? "" : labelTextOrUndefined
              )
          );

          $label.append($element);
        });

        // DCC-3325
        const $eleadsProductInterestC = getEleadsProductInterestC($form);

        if (
          getCommentC($form).length > 0 &&
          $eleadsProductInterestC.length > 0 &&
          getMktoFinTestimonialconsent($form).length > 0 &&
          getMktoPersonNotes($form).length > 0
        ) {
          $eleadsProductInterestC.on("change", () => {
            showOrHideCommentC($form);
          });
        }

        showFirstStepIfTrueSecondStepIfFalse(true);

        const $termsConditionsRow = containerizeSelector(".termsConditionsRow");

        // Move terms/conditions row into the form so that data from all contained fields is sent to Marketo without any extra work
        if ($termsConditionsRow.length > 0) {
          const $formRowDivChildren = $form.find("> div.row");

          if ($formRowDivChildren.length > 0) {
            $termsConditionsRow
              .detach()
              .insertAfter($formRowDivChildren.last());
          } else {
            dnbComLog(
              LogSeverity.WARN,
              "Could not find last row in form, appending terms/conditions row to form instead of inserting after last row"
            );

            $termsConditionsRow.detach().appendTo($form);
          }
        }

        // The presence or absence of this value in the data sent to Marketo is determined by whether the checkbox is checked, so if it's checked, "1" should be sent, not "0" (which is currently the value set)
        containerizeSelector('[name="cAFormEmailOptIn"]').val("1");

        getLeadFormSubmitButton().prop("disabled", true);

        // Contact process tooltip in form legal disclaimer
        const showClass = "show";

        getLegal()
          .find(".agreement")
          .each((_, ht) => {
            const $this = $(ht);

            const $details = $this.find(".details");

            $this
              .find("a.contact_show")
              .on("mouseover", () => {
                $details.addClass(showClass);
              })
              .on("mouseout", () => {
                $details.removeClass(showClass);
              })
              .on("click", (eventObject) => {
                eventObject.preventDefault();
                eventObject.stopPropagation();
              });
          });

        const $nextButton = getLeadFormNextButton();

        const $formCountry = containerizeSelector('[id="form-country"]');
        const $formCustservsubmitemail = containerizeSelector(
          '[id="form-custservsubmitemail"]'
        );
        const $formFirstname = containerizeSelector('[id="form-firstname"]');

        $nextButton
          .add($formCustservsubmitemail)
          .on("keydown", (eventObject) => {
            if (eventObject.which === keycode.codes.enter) {
              $nextButton.trigger("click");

              if (focusFormFirstname) {
                $formFirstname.trigger("focus");
              }
            }
          });

        if (isTwoStep) {
          $nextButton.on("click", () => {
            $formCustservsubmitemail
              .siblings()
              .not(".lead-form-label-div")
              .remove();

            $formCustservsubmitemail.removeClass(formErrorClassName);

            const validateEmailError = validateEmail($formCustservsubmitemail);

            if (isNotUndefined(validateEmailError)) {
              addError(
                $formCustservsubmitemail,
                getLocalizedMessage(validateEmailError, languageToUse)
              );
            } else {
              $formFirstname.trigger("focus");

              showFirstStepIfTrueSecondStepIfFalse(false);

              const windowDigitalData = getWindowDigitalData();

              const contentId = windowDigitalData?.page.pageInfo.contentID;

              if (
                isNotUndefined(contentId) &&
                contentId.length > 0 &&
                $formCountry.length > 0
              ) {
                let countryToSet: string | undefined = void 0;
                let postalcodePlaceholderToSet: string | undefined = void 0;

                if (contentId.includes("/dnb-uk/en/")) {
                  countryToSet = "GB";
                  postalcodePlaceholderToSet = "Postcode";
                } else if (contentId.includes("/dnb-ie/en/")) {
                  countryToSet = irelandIsoCode;
                  postalcodePlaceholderToSet = "Postcode";
                } else if (contentId.includes("/dnb-ca/")) {
                  countryToSet = canadaIsoCode;
                }

                if (isNotUndefined(countryToSet)) {
                  $formCountry.val(countryToSet);
                }

                if (isNotUndefined(postalcodePlaceholderToSet)) {
                  containerizeSelector('[id="form-postalcode"]').attr(
                    "placeholder",
                    postalcodePlaceholderToSet
                  );
                }
              }
            }
          });
        }

        const formCountryInitialValue = $formCountry.val();

        $formCustservsubmitemail.on("change", () => {
          const formCountryValueChanged =
            $formCountry.val() !== formCountryInitialValue;

          const idsOfElementsToCheck = [
            "form-companyname",
            "form-address",
            "form-postalcode",
          ];

          const domain = valToString($formCustservsubmitemail.val()).replace(
            /.*@/,
            ""
          );
          if (Boolean(emailDomainBlocklist.includes(domain))) {
            return;
          }

          // Only auto-fill fields if not already set
          if (
            !anyElementWithIdInArraySet(idsOfElementsToCheck) &&
            !formCountryValueChanged
          ) {
            const contentId = getWindowDigitalData()?.page.pageInfo.contentID;
            const contentIdToUse =
              typeof contentId === "string" ? contentId : "";

            // Used to be called "limituk"
            let countryIsoAlphaTwoCodeParameter: string | undefined;

            if (contentIdToUse.includes("/content/dnb-uk/")) {
              countryIsoAlphaTwoCodeParameter = "GB";
            } else if (contentIdToUse.includes("/content/dnb-ie/")) {
              countryIsoAlphaTwoCodeParameter = irelandIsoCode;
            } else {
              countryIsoAlphaTwoCodeParameter = void 0;
            }

            if (
              valToString($formCustservsubmitemail.val()).replace(/.*@/, "")
                .length > 0
            ) {
              getDnbDirectUtilForEmail(countryIsoAlphaTwoCodeParameter, domain)
                .then((ax) => {
                  const data = ax.data;

                  const dataMatchCandidates = data.matchCandidates;

                  if (
                    isNotUndefined(dataMatchCandidates) &&
                    dataMatchCandidates !== null
                  ) {
                    const firstMatchCandidate = data.matchCandidates[0];

                    if (
                      isNotUndefined(firstMatchCandidate) &&
                      firstMatchCandidate !== null
                    ) {
                      const organization = firstMatchCandidate.organization;

                      if (
                        isNotUndefined(organization) &&
                        organization !== null
                      ) {
                        const stringifyIfNotStringThenRemoveQuotes = (
                          input: any
                        ): string | undefined => {
                          let stringValue: string | undefined;

                          if (typeof input === "string") {
                            stringValue = input;
                          } else if (isUndefinedOrNull(isUndefined)) {
                            stringValue = void 0;
                          } else {
                            stringValue = window.JSON.stringify(input);
                          }

                          return isNotUndefined(stringValue)
                            ? stringValue.replace(/"/g, "")
                            : stringValue;
                        };

                        const setValueAndApplyColorChange = (
                          id: string,
                          value: string | undefined
                        ) => {
                          const $id = containerizeSelector(`[id="${id}"]`);

                          const leadFormAutomaticallyFilledColorClassName =
                            "leadFormAutomaticallyFilledColor";

                          if ($id.length > 0 && isNotUndefined(value)) {
                            $id
                              .val(value)
                              .addClass(
                                leadFormAutomaticallyFilledColorClassName
                              )
                              .on("input", () => {
                                $id.removeClass(
                                  leadFormAutomaticallyFilledColorClassName
                                );
                              });
                          }
                        };

                        const primaryName =
                          stringifyIfNotStringThenRemoveQuotes(
                            organization.primaryName
                          );

                        setValueAndApplyColorChange(
                          "form-companyname",
                          primaryName
                        );

                        const primaryAddress = organization.primaryAddress;

                        if (
                          isNotUndefined(primaryAddress) &&
                          primaryAddress !== null
                        ) {
                          const lineOne = stringifyIfNotStringThenRemoveQuotes(
                            primaryAddress.streetAddress.line1
                          );
                          const lineTwo = stringifyIfNotStringThenRemoveQuotes(
                            primaryAddress.streetAddress.lineTwo
                          );
                          const postalCode =
                            stringifyIfNotStringThenRemoveQuotes(
                              primaryAddress.postalCode
                            );
                          const postalCodeExtension =
                            stringifyIfNotStringThenRemoveQuotes(
                              primaryAddress.postalCodeExtension
                            );
                          const city = stringifyIfNotStringThenRemoveQuotes(
                            primaryAddress.addressLocality.name
                          );
                          const isoAlphaTwoCode =
                            stringifyIfNotStringThenRemoveQuotes(
                              primaryAddress.addressCountry.isoAlpha2Code
                            );

                          const address = isUndefined(lineOne)
                            ? void 0
                            : lineOne +
                              (isUndefined(lineTwo) ? "" : `, ${lineTwo}`);

                          const isUs =
                            isNotUndefined(isoAlphaTwoCode) &&
                            /^us$/i.test(isoAlphaTwoCode);
                          const usPostalCodeExtension =
                            !isUs || isUndefined(postalCodeExtension)
                              ? ""
                              : `-${postalCodeExtension}`;
                          const postalCodeWithPostalCodeExtension = isUndefined(
                            postalCode
                          )
                            ? void 0
                            : postalCode + usPostalCodeExtension;

                          setValueAndApplyColorChange("form-address", address);
                          setValueAndApplyColorChange("form-city", city);
                          setValueAndApplyColorChange(
                            "form-postalcode",
                            postalCodeWithPostalCodeExtension
                          );
                          setValueAndApplyColorChange(
                            "form-country",
                            isoAlphaTwoCode
                          );
                        }
                      }
                    }
                  }
                }).catch(error => dnbComLog(LogSeverity.ERROR, error));
            }
          }
        });

        setFormFromContext();
        setGUIDVisitorID();
        setCreativeID();
        setVisitFromDate();
        setMisc();

        // Set lead form routing
        // Form name

        // This is hacky but there may be a reason to put these in the DOM rather then just adding the keys and values in the submitForm function

        const safelyAddRoutingData = (inputName: string, value: any) => {
          const containerClassName = "eloquaFormRouting";

          const $container = containerizeSelector(`.${containerClassName}`);

          let $containerToUse;

          if ($container.length > 0) {
            $containerToUse = $container;
          } else {
            const $newEloquaFormRouting =
              $("<div></div>").addClass(containerClassName);

            $form.append($newEloquaFormRouting);

            $containerToUse = $newEloquaFormRouting;
          }

          const $input = $containerToUse.find(`input[name="${inputName}"]`);

          let $inputToUse;

          if ($input.length > 0) {
            $inputToUse = $input;
          } else {
            const $newInput = $("<input>")
              .attr("name", inputName)
              .attr("type", "hidden");

            $containerToUse.append($newInput);

            $inputToUse = $newInput;
          }

          $inputToUse.val(value);
        };

        let formIdToAdd;
        let formVidToAdd;
        let munchkinIdToAdd;

        if (leadFormSettingsLeadFormSettings.formId.length > 0) {
          formIdToAdd = leadFormSettingsLeadFormSettings.formId;
          formVidToAdd = leadFormSettingsLeadFormSettings.formId;
          munchkinIdToAdd = leadFormSettingsLeadFormSettings.munchkinId;
        } else if (
          leadFormSettingsLeadFormSettings.thankyouPage.includes(
            "/content/dnb-uk/"
          )
        ) {
          formIdToAdd = "1022";
          formVidToAdd = "1022";
          munchkinIdToAdd = "293-HCU-961";
        } else {
          formIdToAdd = "1028";
          formVidToAdd = "1028";
          munchkinIdToAdd = "080-UQJ-704";
        }

        safelyAddRoutingData("formid", formIdToAdd);
        safelyAddRoutingData("formVid", formVidToAdd);
        safelyAddRoutingData("munchkinId", munchkinIdToAdd);

        if (leadFormSettingsLeadFormSettings.warmTransferId.length > 0) {
          safelyAddRoutingData(
            "Warm_Transfer_Name__c",
            leadFormSettingsLeadFormSettings.warmTransferId
          );
        }

        windowOnLoadOrImmediate($(window), () => {
          const promise = new window.Promise<string>((re) => {
            if (
              isNotUndefined(xForwardedForFirstElement) &&
              xForwardedForFirstElement.length > 0
            ) {
              re(xForwardedForFirstElement);
            } else {
              axios
                .get("https://api.ipify.org", {
                  params: {
                    format: "json",
                  },
                })
                .then((ax) => {
                  const ip = ax.data.ip;
                  const isValidIPv4 = (ip: string) => /^(\d{1,3}\.){3}\d{1,3}$/.test(ip);
                  if(isValidIPv4(ip)) {
                    return re(ip);
                  }
                  else {
                    dnbComLog(LogSeverity.ERROR, "Invalid IP address format");
                  }
                })
                .catch((error) => {
                  dnbComLog(LogSeverity.ERROR, error);
                });
            }
          }).then((st) =>
            containerizeSelector('input[name="IPAddress__c"]').val(st)
          );

          const $submitButton = getLeadFormSubmitButton();

          $submitButton.on("click", () =>
            promise.finally(() => {
              if ($submitButton.prop("disabled") === false) {
                $submitButton.prop("disabled", true).addClass("submitted");

                // Re-enable submit button if validation fails
                if (!submitForm()) {
                  $submitButton.prop("disabled", false);
                }
              }
            })
          );

          $submitButton.prop("disabled", false);

          const {
            formId,
            marketourl,
            munchkinId,
            thankyouMessage,
            thankyouPage,
          } = leadFormSettingsLeadFormSettings;

          lazyLoadScriptMarketo(marketourl).addRunAfterScriptLoadCallback(
            (mktoFormsTwo) =>
              mktoFormsTwo.loadForm(
                marketourl,
                munchkinId,
                formId,
                (marketoForm: any) => {
                  if (isUndefinedOrNull(marketoForm)) {
                    dnbComLog(
                      LogSeverity.ERROR,
                      "marketoForm is undefined or null",
                      marketourl,
                      munchkinId,
                      formId
                    );
                  } else {
                    marketoFormWrapper.runMarketoFormLoadCallbacks(marketoForm);
                    const vals = marketoForm.vals();
                    if (
                      isNotUndefinedOrNull(vals) &&
                      isNotUndefinedOrNull(vals.formGroupID)
                    ) {
                      safelyAddRoutingData("formGroupID", vals.formGroupID);
                    }

                    marketoForm.onSubmit((_marketoForm: any) =>
                      dnbComLog(LogSeverity.INFO, "MktoForms2 onSubmit fired")
                    );

                    marketoForm.onValidate((validationSucceeded: any) => {
                      dnbComLog(
                        LogSeverity.INFO,
                        "MktoForms2 onValidate fired"
                      );

                      if (validationSucceeded === true) {
                        dnbComLog(
                          LogSeverity.INFO,
                          "MktoForms2 onValidate callback was called with the boolean value true (validation succeeded)"
                        );
                      } else if (validationSucceeded === false) {
                        dnbComLog(
                          LogSeverity.ERROR,
                          new Error(
                            "MktoForms2 onValidate callback was called with the boolean value false (validation failed)"
                          )
                        );
                      } else {
                        dnbComLog(
                          LogSeverity.WARN,
                          new Error(
                            `MktoForms2 onValidate callback was called with an argument of an unexpected type: ${typeof validationSucceeded}`
                          )
                        );
                      }

                      // The point of this might be to try to force form submission to proceed even if the Marketo validation fails
                      marketoForm.submittable(true);
                    });

                    marketoForm.onSuccess(
                      (
                        _valuesSubmitted: any,
                        _followUpPageUrl: any
                      ): boolean => {
                        dnbComLog(
                          LogSeverity.INFO,
                          "MktoForms2 onSuccess fired"
                        );
                        let formData: Record<string, any> = {};

                        if (isNotUndefinedOrNull(_valuesSubmitted)) {
                          formData = { ..._valuesSubmitted };

                          trackGTMEvents({
                            event: "formSubmit",
                            formData: formData,
                          });
                        } else {
                          dnbComLog(
                            LogSeverity.WARN,
                            '"valuesSubmitted" is undefined or null, cannot add data to "formData"'
                          );
                        }

                        if (thankyouPage.length > 0) {
                          window.location.href = thankyouPage;
                        } else {
                          // Get the form's jQuery element and hide it
                          // Return false to prevent the submission handler from taking the lead to the follow-up URL
                          const $thankYouMessage = getThankYouMessage();

                          $thankYouMessage.html(thankyouMessage);
                          containerizeSelector(".leadform-form").hide();
                          $thankYouMessage.show();
                        }

                        marketoForm.getFormElem().hide();

                        return false;
                      }
                    );
                  }
                }
              )
          );
        });
      };

      if (isCtaLeadForm) {
        if ($(".ctabar").length > 0 && $(".contact_cta .cta").length > 0) {
          setupLeadForm();

          $(".ctabar .lead-form .row:last .default a:last").on(
            "keydown",
            (eventObject) => {
              // Tab key
              if (eventObject.which === 9 && !eventObject.shiftKey) {
                eventObject.preventDefault();

                $('.ctabar [id="form-firstname"]').trigger("focus");
              }
            }
          );
        } else {
          // In this branch, the lead form setup is not performed
          dnbComLog(
            LogSeverity.ERROR,
            new Error('".ctabar" or ".contact_cta .cta" not found')
          );
        }
      } else {
        setupLeadForm();
      }
    });
  }, []);

  const leadformForm = "leadform-form";

  const shared = (
    <>
      {notEmptyString(pTitle) || notEmptyString(pInstructions) ? (
        <div className={`row leadFormTitleAndSubtitleRow`}>
          <div className="col-md-12">
            {
              // Form title
            }

            {notEmptyString(pTitle) && typeof pTitle === "string" ? (
              <div
                className="title"
                dangerouslySetInnerHTML={{ __html: pTitle }}
              />
            ) : (
              <></>
            )}

            {
              // Form instructions
            }

            {notEmptyString(pInstructions) &&
            typeof pInstructions === "string" ? (
              <div
                className="subtitle"
                style={{'fontSize': '16px'}}
                dangerouslySetInnerHTML={{ __html: pInstructions }}
              />
            ) : (
              <></>
            )}
          </div>
        </div>
      ) : (
        <></>
      )}

      <div
        className="leadFormFormWrapper"
        dangerouslySetInnerHTML={{
          __html: notEmptyString(pSelectEloquaFormContentUnescapeJava)
            ? pSelectEloquaFormContentUnescapeJava!
            : defaultHtml
            
            // getDefaultLeadFormHtmlAssetInlineBaseSixtyFourDecoded(),
        }}
      />

      {/* {notEmptyString(pTandc) && typeof pTandc === "string" ? (
        <div className={`row termsConditionsRow`}>
          <div className="col-md-12">
            <div
              className="terms-conditions"
              dangerouslySetInnerHTML={{ __html: pTandc }}
            />
          </div>
        </div>
      ) : (
        <></>
      )} */}

      <div className="row">
        <div className={`col-md-12 leadFormNextAndSubmitButtonWrapper`}>
          <label>
            <input
              className={`leadFormNextButton`}
              type="button"
              value="Next"
            />
          </label>

          <label>
            <input
              className={"leadFormSubmitButton"}
              type="button"
              value={pSubmitButtonText}
            />
          </label>
        </div>
      </div>

      {
        // Legal text
      }

      {notEmptyString(pFormLegal) && typeof pFormLegal === "string" ? (
        <div className="row">
          <div className="col-md-12">
            <div
              className="legal"
              dangerouslySetInnerHTML={{ __html: pFormLegal }}
            />
          </div>
        </div>
      ) : (
        <></>
      )}

      {
        // Hidden button for analytics. Analytics reporting occurs on click.
      }

      <input id="eloquasubmit" style={{ display: "none" }} type="button" />
    </>
  );

  return (
    <div
      className={"leadFormIdentifierWrapper"}
      ref={leadFormIdentifierWrapperReference}
    >
      {fromFloatingContactOptions ? (
        <div className={leadformForm}>{shared}</div>
      ) : (
        <>
          {
            // Need id="leadform-form" because of JavaScript in content
          }
{/* ${componentclass}  */}
          <div
            className={
            `single-column
             sidebar-leadform
              ${leadformForm}`}
            id="leadform-form"
          >
            {shared}
          </div>

          {
            // Thank you message after submit
          }

          <div className="thank-you-msg" />
        </>
      )}
    </div>
  );
};

// const handleLeadForm = (renderableData: RenderableData<HandleLeadFormParameter>): void =>
//     renderIdentifierGeneric(
//         LeadFormSharedComponent,
//         addToRenderableData(
//             renderableData,
//             {
//                 "fromFloatingContactOptions": false,
//             }
//         ));

// export {handleLeadForm, LeadFormSettings, LeadFormSharedComponent};

export default LeadFormSharedComponent;
